<template>
<v-layout row justify-center align-center fill-height style="margin:0 10%">
        <v-flex xs12 sm12 md12 order-md1>
            <div class="vv-heading text-xs-center text-md-left">{{title}}</div>
            <div class="vv-subheading  text-xs-center text-md-left">
            {{subtitle}}
            </div>
            <br>
            <div class="vv-subheading  text-xs-center text-md-left">
            {{end}}
          </div>
        </v-flex>
</v-layout>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    show: false,
    isList: false,
    title: 'Frequently Asked Questions:',
    subtitle: `Question 1:`,
    end: 'Answer: '
  }),
  methods: {
    toRoute (rname, rparams = {}, query = {}) {
      this.$router.push({name: rname, params: rparams, query: query})
    }
  }
}
</script>
<style scoped lang="scss">
.vv-logo {
  max-width: 100%;
}

.vv-heading {
  padding-bottom: 30px;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;
  text-align: center;
	font-size: 30px;
	font-weight:200;
}

.vv-subheading {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;
  text-align: center;
	font-size: 20px;
	font-weight:200;
}
.vv-cta {
  padding-top: 30px;
}

.vv-patreon-logo {
  max-width: 22px;
  margin-right: 5px;
}

.vv-card-text {
  padding-top: 15px;
}

@media (max-width: 960px) {
  .vv-heading {
    padding-bottom: 15px;
  }

  .vv-logo {
    max-width: 240px;
  }

  .vv-cta {
    padding-top: 10px;
    text-align: center;
  }
}

@media (max-width: 420px) {
  .vv-heading {
    padding-bottom: 10px;
    line-height: 100%;
  }

  .vv-logo {
    max-width: 160px;
  }

  .vv-cta {
    padding-top: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/FAQ.vue